<template>
    <form
        ref="form"
        @submit.prevent="submit"
        :action="formRoute"
        method="POST"
        class="relative h-full"
    >
        <page-header
            :submit-button-text="data ? 'Update' : 'Create'"
            :show-submit-button="true"
            :submit-button-disabled="submitButtonDisabled || !editable"
            submit-button-type="submit"

            :can-delete="canDelete"
            :delete-route="deleteRoute"
            :delete-value="deleteValue"

            :can-create="canCreate"
            :create-route="createRoute"
            :create-value="createValue"
            :create-disabled="createDisabled"
            :create-tooltip="createTooltip"

            :index-route="indexRoute"
            :index-value="indexValue"
            :title="title"
            :subtitle="subtitle"

            :show-preview-button="false"

            :errors="errors"
            :is-slide-over="isSlideOver"

            :version-id="versionId"
            :init-version-id="initVersionId"
            :last-updated-by="lastUpdatedBy"
        />

        <Select
            label="* Error Code"
            name="name"
            v-model="form.name"
            :options="errorCodeOptions"
            :error="errors.name ? errors.name[0] : null"
            :disabled="!!form.baseDocument || !!data"
        />

        <input-text
            name="title"
            label="* Title"
            v-model="form.title"
            :error="errors.title ? errors.title[0] : null"
            :maxlength=255
            class="mt-3"
        />

        <input-text
            name="subtitle"
            label="* Subtitle"
            v-model="form.subtitle"
            :error="errors.subtitle ? errors.subtitle[0] : null"
            :maxlength=255
            class="mt-3"
        />

        <error-page-linked-pages
            class="mt-3"
            v-model="form.linked_pages"
            :errors="errors"
            :fixed-items-count="true"
            :language="form.language"
        />

        <input type="hidden" name="_token" :value="csrf" />
        <input v-if="data" type="hidden" name="_method" value="patch" />
    </form>
</template>
<script>
import crudForm from '../mixins/crudForm';

export default {
    name: "ErrorPageForm",
    mixins: [crudForm],
    props: {
        errorCodes: {
            type: Array,
            required: true,
        },
        excludedErrorCodes: {
            type: Array,
            required: false,
            default() {
                return [];
            },
        },
        createDisabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        createTooltip: {
            type: String,
            required: false
        },
    },
    mounted: function () {
        // we want 3 linked pages by default
        if (this.form.linked_pages.length < 3) {
            let count = 3 - this.form.linked_pages.length;
            for (let i = 0; i < count; i++) {
                this.form.linked_pages.push({
                    key: Math.random().toString(16).substr(2, 8),
                    document: null,
                    order: this.form.linked_pages.length,
                    collapsed: false,
                });
            }
        }

        // if this is a translation we want it to have the same name (which is the error code) as the base document
        if (!!this.form.baseDocument && !this.form.name) {
            this.form.name = this.form.baseDocument.name;
        }
    },
    data(){
        return {
            form: {
                name: this.getFormData('name'),
                title: this.getFormData('title'),
                subtitle: this.getFormData('subtitle'),
                linked_pages: this.getFormData("linked_pages", []),
            }
        }
    },
    computed: {
        errorCodeOptions(){
            return this.errorCodes
            .filter(errorCode => {
                return !this.excludedErrorCodes.includes(errorCode);
            })
            .map(errorCode => {
                return {value: errorCode, name: errorCode};
            });
        },
    }
}
</script>
